export default "__VITE_ASSET__DlmA9dYv__"